'use client';

import type { ReactNode } from 'react';
import type { SectionType } from '~/model/SectionType';
import { VpButton, VpIcon } from '@vtmn-play/react/headless';
import HTMLReactParser from 'html-react-parser';
import { useTranslations } from 'next-intl';
import { getResizedPictureUrl } from '@/app/utils/entities/media';
import { ResizedImg } from '~/components/commons/ResizedImg/ResizedImg';
import { Zoom } from '~/components/commons/Zoom/Zoom';

export const Section = ({
  section,
  langValue,
  number,
  start,
  translateButtonComponent,
}: {
  section: SectionType;
  langValue: string;
  number?: number;
  start?: () => void;
  translateButtonComponent?: ReactNode;
}) => {
  const t = useTranslations('FORM.SECTION');

  return (
    <div data-testid="section" className="section">
      {!!number && (
        <div className="section__top">
          <p className="vp-body-m">
            {t('TITLE')}
            {' '}
            {number}
          </p>
        </div>
      )}
      {section?.title && (
        <div className="section__title">
          <h1 lang={langValue} className="vp-title-l">
            {section.title}
          </h1>
        </div>
      )}
      {section?.body && (
        <div className="section__description">
          <div lang={langValue} className="vp-body-m">
            {HTMLReactParser(section.body)}
          </div>
        </div>
      )}
      {translateButtonComponent}
      {section?.media?.content_url && (
        <div className="section__picture">
          <div className="section__media">
            <div className="section__inner">
              <ResizedImg
                data-testid="section-image"
                src={section?.media?.content_url}
                format="1042x0"
                width={600}
                height={400}
                alt=""
                loading="eager"
              />
              <Zoom
                mainSrc={getResizedPictureUrl(
                  section?.media?.content_url,
                  '1600x0',
                )}
              />
            </div>
          </div>
        </div>
      )}
      {!!start && (
        <div className="section__cta">
          <VpButton
            data-cy="section-start-btn"
            data-testid="section-start-btn"
            type="button"
            endSlot={<VpIcon name="arrow-right" />}
            shape="squared"
            onClick={start}
          >
            {t('CTA')}
          </VpButton>
        </div>
      )}
    </div>
  );
};
